// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"123":"2a1ce81d","534":"2e2e88be","616":"9abe5884","737":"23f92eec"}[chunkId] + ".css";
};